<template>
  <!-- sidenav -->
  <div class="iframe-section">
    <div class="krx-sidenav">
      <div
        class="side-title"
        style="padding-top: 11px; cursor: pointer;"
        @click="goLogo('kMeeting')"
      >
        <img
          src="../../../src/images/smartlogo.png"
          style="width: 32px; height: 32px; margin-left: 30px;"
        />
        <div style="margin-left:10px; font-size: 20px; font-weight: bold;">
          스마트회의
        </div>
      </div>
      <button
        class="join-meeting-btn"
        style="width: 70%;
      margin-left: 30px;
      height: 40px;
      margin-top: 20px;"
        @click="openJoinMeetingDialog"
      >
        회의 접속
      </button>
      <ul style="margin-top: 24px;">
        <li :class="page.class" v-for="page in pageList" :key="page.link">
          <div class="side-list" style="margin-top: 5px;">
            <img :src="page.imagePath" />
            <div class="txt">{{ page.title }}</div>
          </div>
          <div
            v-for="obj in page.child"
            :key="obj.href"
            class="flex flex-row items-center child-row side-list"
            @click="currentPage(obj)"
          >
            <img
              :class="obj.class"
              style="margin-left: 15px;"
              :src="obj.imagePath"
            />
            <span :class="obj.class">{{ obj.title }}</span>
          </div>
        </li>
      </ul>

      <citizen-participation-dialog
        :dialog="citizenParticipationDialog.dialog"
        :closeDialog="closeJoinMeetingDialog"
      />
    </div>
    <iframe
      id="kMeetingIframe"
      class="kmeeting-iframe"
      :src="iframeLink"
    ></iframe>
  </div>
</template>

<script>
import Util from '@/util';
import CitizenParticipationDialog from '@/components/popup/CitizenParticipationDialog';
export default {
  components: {
    CitizenParticipationDialog,
  },
  data: () => ({
    iframeLink: '/testPage',
    citizenParticipationDialog: {
      dialog: false,
    },
    isActive: false,
    pageList: [
      {
        class: 'm01',
        link: '/myMeeting',
        title: '스마트회의',
        imagePath: '/static/images/button/all.svg',
        isActive: false,
        child: [
          {
            class: 'm02',
            link: 'video',
            title: '영상회의',
            imagePath: '/static/images/button/krxVideo.svg',
          },
          {
            class: 'active',
            link: 'conf',
            title: '회의록 작성',
            imagePath: '/static/images/button/conf.png',
          },
        ],
      },
      // {
      //   title: '부가기능',
      //   imagePath: '/static/images/button/etcFunc.svg',
      //   isActive: false,
      //   child: [
      //     {
      //       class: 'active',
      //       link:
      //         'https://kgw.krx.co.kr:8443/initech/sso/sso.jsp?UURL=linkedURI%3D%2FezResource%2FresMain.do',
      //       title: '회의실 신청',
      //       imagePath: '/static/images/button/addRoom.png',
      //     },
      //     {
      //       class: 'active',
      //       link: 'conf',
      //       title: '회의록 작성',
      //       imagePath: '/static/images/button/conf.png',
      //     },
      //   ],
      // },
      // {
      //   class: "m03",
      //   link: "/joinMeeting",
      //   title: "일반회의",
      //   imagePath: "/static/images/button/krxGeneral.svg",
      //   isActive: false,
      // },
      // {
      //   class: "m04",
      //   link: "/manageVideoMeetingRoom",
      //   imagePath: "/static/images/button/etcFunc.svg",
      //   title: "부가기능",
      //   isActive: false,
      // },
    ],
  }),
  created() {
    if (!Util.hasSession(this, true)) return;
  },
  methods: {
    currentPage: function(obj) {
      console.log(obj);
      if (obj.title === '회의실 신청') {
        window.open(obj.link, '_blank');
      } else if (obj.link === 'video') {
        this.iframeLink = '/testPage';
      } else if (obj.link === 'conf') {
        window.open(
          'https://kminutes.krx.co.kr?userKey=' + this.$store.state.token,
          '_blank'
        );
      } else if (obj.link === 'general') {
        let dept = this.$store.state.user.deptCode.toLowerCase();
        this.iframeLink = `https://kgw.krx.co.kr:8443/initech/sso/sso.jsp?UURL=aprDeptID%3D${dept}%26linkedURI%3D%2FezPaperless%2FpaperlessMain.do%3Fbz_tp_cd%3DC`;
      }
      this.pageList.forEach((element) => {
        element.isActive = false;
      });

      obj.isActive = true;
    },
    goLogo() {
      this.$router.go(0);
    },
    goUserPage() {
      this.$router.push(`/myMeeting`);
    },
    openJoinMeetingDialog() {
      this.citizenParticipationDialog.dialog = true;
    },
    closeJoinMeetingDialog() {
      this.citizenParticipationDialog.dialog = false;
    },
  },
};
</script>

<style scoped>
.side-list {
  display: flex;
  flex-direction: row;
  justify-items: center;
  align-items: center;
  margin-left: 30px;
  height: 32px;
  width: 173px;
  cursor: pointer;
  font-size: 13px;
  color: #333;
}

.side-list img {
  width: 16px;
  height: 16px;
}
.side-list:hover {
  border-radius: 4px;
  background: rgba(100, 73, 252, 0.06);
}
.txt {
  margin-left: 6px;
  font-size: 13px;
  color: #333;
}

.child-row span {
  font-size: 13px;
  margin-left: 6px;
}

.no-active {
  color: #cccccc;
}

.iframe-section {
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/components/krx/TestKrxLeftSide.vue